import { capitalize } from '@/modules/shared/shared/domain/functions/string-functions';

const monthNames = [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
];

export function getMonthFullName(monthNumber: number): string {
    return monthNames[monthNumber - 1];
}

export function getMonthShortName(monthNumber: number): string {
    return monthNames[monthNumber - 1].substring(0, 3);
}

export function setFormatDate(fulldate: string) {
    const date: any = new Date(fulldate);
    let year: any = date.getFullYear();
    let month: any = date.getMonth() + 1;
    let dt: any = date.getDate();

    if (dt < 10) {
        dt = '0' + dt;
    }
    if (month < 10) {
        month = '0' + month;
    }

    return dt + '/' + month + '/' + year;
}

// Returns date with the format: martes, 12 de abril de 2020 8:00 AM
export function getFullDate(dateWithTimezone: string): string {
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'short',
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        hour12: true,
    };
    return new Date(dateWithTimezone).toLocaleString('es-es', options);
}

// Returns date with the format: 12 de abril de 2020
export function getDate(dateWithTimezone: string): string {
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    };
    return new Date(dateWithTimezone).toLocaleString('es-es', options);
}

export function setLongFormatDate(date: string) {
    if (date == '') {
        return '';
    } else if (date !== undefined) {
        let dateSnippet = date.split('-');
        let formattedDate =
            dateSnippet[2] +
            ' de ' +
            getMonthFullName(parseInt(dateSnippet[1])) +
            ' de ' +
            dateSnippet[0];
        return formattedDate;
    } else {
        return date;
    }
}

export function setMonthFormatDate(date: string) {
    if (date == '') {
        return '';
    } else if (date !== undefined) {
        let dateSnippet = date.split('-');
        let formattedDate =
            capitalize(getMonthFullName(parseInt(dateSnippet[1]))) + ' de ' + dateSnippet[0];
        return formattedDate;
    } else {
        return date;
    }
}

export function getTimeFromDate(date: string) {
    let fullDate: string = getFullDate(date);
    let fullDateSnippets: string[] = fullDate.split(' ');
    return (
        fullDateSnippets[fullDateSnippets.length - 2] +
        ' ' +
        fullDateSnippets[fullDateSnippets.length - 1]
    );
}

export function translateMonths(mes) {
    let month: string = '';
    switch (mes) {
        case 'January':
            month = 'Enero';
            return month;
        case 'February':
            month = 'Febrero';
            return month;
        case 'March':
            month = 'Marzo';
            return month;
        case 'April':
            month = 'Abril';
            return month;
        case 'May':
            month = 'Mayo';
            return month;
        case 'June':
            month = 'Junio';
            return month;
        case 'July':
            month = 'Julio';
            return month;
        case 'August':
            month = 'Agosto';
            return month;
        case 'September':
            month = 'Septiembre';
            return month;
        case 'October':
            month = 'Octubre';
            return month;
        case 'November':
            month = 'Noviembre';
            return month;
        case 'December':
            month = 'Diciembre';
            return month;
        default:
            return month;
    }
}
